import React, { useCallback, useState } from 'react';
import BrokerTabs from '../components/BrokerTabs';
import BrokerContent from '../components/BrokerContent';
import { ToastProvider } from '../components/Toast';
import useBrokerEmail from '../hooks/useBrokerEmail';
import useBrokerTab from '../hooks/useBrokerTab';
import './BrokerDashboard.css';

const BrokerDashboard = () => {
    const { tab, filters, goTo } = useBrokerTab();
    const { email: brokerEmail, error: emailError } = useBrokerEmail();

    const [tabCounts, setTabCounts] = useState({});
    const onTabCount = useCallback((key, n) => {
        setTabCounts((prev) => (prev[key] === n ? prev : { ...prev, [key]: n }));
    }, []);

    return (
        <ToastProvider>
            <div className="broker-dashboard">
                <div className="broker-shell">
                    <header className="broker-shell-header">
                        <div>
                            <h1>Broker</h1>
                            <p className="broker-subtitle">
                                {brokerEmail
                                    ? 'Your inventory, listings, and orders.'
                                    : emailError || 'Loading session…'}
                            </p>
                        </div>
                    </header>

                    <BrokerTabs activeTab={tab} onChange={(t) => goTo({ tab: t })} counts={tabCounts} />

                    <BrokerContent
                        tab={tab}
                        brokerEmail={brokerEmail}
                        filters={filters}
                        goTo={goTo}
                        onTabCount={onTabCount}
                    />
                </div>
            </div>
        </ToastProvider>
    );
};

export default BrokerDashboard;
